import React, { useEffect, useState } from 'react';
import { Button, message, Modal, Empty, Radio, Spin } from 'antd';
import 'moment/locale/zh-cn';
import { imgAuditWithPass, fetchImgAuditDetail, deleteNoPassImg, checkAuditPassImg } from '../../../../api/inspiration';
import WaterFall from '../../../../component/WaterFall';
import './index.less';

const getUsername = () => {
    return localStorage.getItem('username');
};

export default React.memo(function AuditModal(props) {
    const { visible, groupItem, setVisible, onUpdate, isCheck } = props;
    const [isLoading, setLoading] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [detailList, setDetailList] = useState([]);
    const [headerInfo, setHeaderInfo] = useState(null);
    const [selectedIds, setSelectedIds] = useState([]);
    const [tipVisible, setTipVisible] = useState(false);
    const [isAllSelected, setAllSelected] = useState(false);

    useEffect(() => {
        if (groupItem && visible) {
            setSelectedIds([]);
            setDetailList([]);
            getImgAuditDetail();
        }
    }, [groupItem, visible]);

    useEffect(() => {
        if (selectedIds.length != 0 && detailList.length != 0 && selectedIds.length == detailList.length && !isAllSelected) {
            setAllSelected(true);
        } else if ((selectedIds.length != detailList.length || selectedIds.length == 0 || detailList.length == 0) && isAllSelected) {
            setAllSelected(false);
        }
    }, [selectedIds]);

    const getImgAuditDetail = async () => {
        if (isLoading) return;
        setLoading(true);
        if (isCheck) {
            const res = await checkAuditPassImg({groupId: groupItem.id});
            if (res?.error?.code == 0 && res.data?.list) {
                setDetailList(res.data.list ?? []);
            } else {
                setDetailList([]);
            }
        } else {
            const res = await fetchImgAuditDetail({groupId: groupItem.id}, getUsername());
            if (res?.error?.code == 0 && res.data) {
                setHeaderInfo({crawlWord: res.data.crawlWord, tagWord: res.data.tagWord});
                setDetailList(res.data.list ?? []);
            } else {
                setHeaderInfo(null);
                setDetailList([]);
            }
        }       

        setLoading(false);
    };

    const allSelect = () => {
        if (isAllSelected) {
            setSelectedIds([]);
        } else {
            const selectList = detailList.map(v => v.id);
            setSelectedIds([...selectList]);
        }
        
        setAllSelected(!isAllSelected);
    };

    const showConfirm = () => {
        setTipVisible(true);
    };

    const toPass = async () => {
        if (!tipVisible && confirmLoading) return;
        setConfirmLoading(true);

        // 通过审核
        const res = await imgAuditWithPass({
            groupId: groupItem?.id,
            classifyWord: headerInfo?.tagWord.split(',')[0] ?? '',
            attrWord: headerInfo?.tagWord.split(',')[1] ?? '',
            crawlWord: headerInfo?.crawlWord,
            idList: selectedIds
        }, getUsername());
        if (res?.error?.code == 0 && res.data) {
                const result = await deleteNoPassImg({
                crawlWord: headerInfo?.crawlWord,
                idList: detailList.filter(v => selectedIds.indexOf(v.id) < 0).map(v => v.id)
            }, getUsername());

            if (result?.error?.code == 0 && res.data) {
                message.success('成功');
                setSelectedIds([]);
                setDetailList([]);
                setVisible(false);
                onUpdate(true);
            } else if (result?.error?.message) {
                message.error(result.error.message);
            } else {
                message.error('删除失败');
            }
        } else if (res?.error?.message) {
            message.error(res.error.message);
        } else {
            message.error('审核失败');
        }
        setTipVisible(false);
        setConfirmLoading(false);
    }

    return (
      <Modal className='imgAudit_modal' visible={visible} width={1550} onCancel={() => setVisible(false)} footer={null}>
        <div className='newAuditMarking1_wrap'>
            <Spin spinning={isLoading}>
                {
                    !isCheck && (
                        <div className='header'>
                            <div className='auditInfo'>
                                <div className='searchWord_wrap'>图片搜索词：{headerInfo?.crawlWord ? <div className='searchWord'>{headerInfo?.crawlWord}</div> : '暂无' }</div>
                                <div className='imgTag_wrap'>图片标签：{headerInfo?.tagWord ? (
                                    <>
                                        {headerInfo.tagWord.split(',')[0] ? <div>{headerInfo.tagWord.split(',')[0]}</div> : null }{headerInfo.tagWord.split(',')[1] ? <div>{headerInfo.tagWord.split(',')[1]}</div> : null }
                                    </>
                                ) : '暂无' }</div>
                            </div>
                            
                            <div className='tail_container'>
                                <div className='selected_count'>
                                    共计<span>{detailList.length}</span>张
                                </div>
                                <div className='selected_count'>
                                    已选择<span>{selectedIds.length}</span>张
                                </div>
                                <div className='radio_wrap' onClick={allSelect}>
                                    <Radio checked={isAllSelected}></Radio>
                                    全选
                                </div>
                            </div>
                        </div>
                    )
                }

                <div className='main'>
                    <div className='imgs_wrap'>
                        <WaterFall
                            list={detailList}
                            selectedIds={selectedIds}
                            setSelectedIds={isCheck ? null : setSelectedIds}
                        />
                    </div>

                    {
                        !isCheck && detailList.length > 0 && (
                            <div className='btns_wrap'>
                                <Button
                                    type="primary"
                                    icon="check-circle"
                                    onClick={showConfirm}
                                    loading={confirmLoading}
                                >
                                    审核通过
                                </Button>
                            </div>
                        )
                    }
                </div>
                
                {
                    !isLoading && detailList.length <= 0 && <Empty description='暂无图片' />
                }
            </Spin>

            <Modal
                title="提示"
                visible={tipVisible}
                onOk={toPass}
                confirmLoading={confirmLoading}
                onCancel={() => setTipVisible(false)}
                maskClosable={false}
                okText='确认'
                cancelText='取消'
                >
                <p>点击确认后即审核通过选中的图片，是否确认？</p>
            </Modal>
        </div>
      </Modal>
    )
        
})